










import { refreshAccessToken } from 'mycorems-app-accounts';
import { HasTaskMixin } from 'mycorems-app-shared';

export default HasTaskMixin.extend({
  props: {
    paymentId: {
      type: String,
      required: true,
    },
  },
  methods: {
    download(): void {
      refreshAccessToken().then(() => {
        window.location.href = `${window.env.MYCOREMS_BILLING.API_URL}/payments/${this.paymentId}/receipt`;
      });
    },
  },
});
